export default "__VITE_ASSET__CjU7wngF__"